import Layout from '@/apps/layout/components'
import ProfessionCompetition from '@/apps/ProfessionCompetition'
import React from 'react'

const ProfessionCompetitionPage = (): React.ReactElement => {
  return (
    <Layout>
      <ProfessionCompetition />
    </Layout>
  )
}

export default ProfessionCompetitionPage
